import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-deselect-icon",
  templateUrl: "./deselect-icon.component.html",
  styleUrls: ["./deselect-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DeselectIconComponent {}
